export const TASK_FADE_DURATION_MS = 500;
export const GroupKeys = {
  STARTER_COMMERCE_PAYMENTS_GROUP: 'starter_commerce_payments_group',
  FREE_COMMERCE_PAYMENTS_GROUP: 'free_commerce_payments_group'
};
export const ChildGroupKeys = {
  COMMERCE_STARTER_CREATE_AND_ACCEPT_PAYMENTS_ONLINE: 'commerce_starter_create_and_accept_payments_online',
  COMMERCE_FREE_CREATE_AND_ACCEPT_PAYMENTS_ONLINE: 'commerce_free_create_and_accept_payments_online',
  COMMERCE_SET_UP_COMMERCE_TOOLS: 'commerce_set_up_commerce_tools'
};